export default "__VITE_ASSET__e5b6d081__"